const General = (state = {
	scripts:[],
	users:[],
	settings:{},
	account:{},
	apps:[],
	plans:[],
	platform:{},
	showProcessing:false,
	sidebarOpen:false,
	companySearchOpen:false,
	dealerSearchOpen:false,
	fullScreen:false,
	showChatReconnection:false,
	needUpdate:false,
	notifications:null,
	shownMessages:[],
	windowHasFocus:null,
}, action) => {

	let newState = state;


	switch(action.type) {
		case 'GENERAL_ADD_MESSAGE':
            newState = {
                ...state,
                shownMessages:[
					...state.shownMessages,
					action.payload,
				]
            }
			break;

		case 'GENERAL_ADD_SCRIPT':
			newState = {
				...state,
				scripts:[
					...state.scripts,
					action.payload
				]
			}
		break;
		case 'GENERAL_SET_SETTING':
			newState = {
				...state,
				settings: {
					...state.settings,
					[action.payload.key]:action.payload.value
				}
			}
		break;
		case 'GENERAL_SET_GLOBAL_KEY':
			newState = {
				...state,
				[action.payload.key]:action.payload.value
			}
		break;
		case 'GENERAL_ADD_USERS':
			newState = {
				...state,
				users:action.payload
			}
		break;

		case 'GENERAL_ADD_ACCOUNT':
			newState = {
				...state,
				account:action.payload
			}
		break;

		case 'GENERAL_ADD_SETTINGS':
			newState = {
				...state,
				settings:action.payload
			}
		break;



	}

	return newState;
}



export default General;



// WEBPACK FOOTER //
// ./reducers/generalReducer.js